/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChipDto } from '../../models/chip-dto';

export interface UnrestrictChip$Json$Params {
  chipNr: number;
}

export function unrestrictChip$Json(http: HttpClient, rootUrl: string, params: UnrestrictChip$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ChipDto>> {
  const rb = new RequestBuilder(rootUrl, unrestrictChip$Json.PATH, 'patch');
  if (params) {
    rb.path('chipNr', params.chipNr, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChipDto>;
    })
  );
}

unrestrictChip$Json.PATH = '/v1/chips/{chipNr}/unrestrict';
